<script setup lang="ts">
import {computed} from 'vue';
import {UseVirtualList} from '@vueuse/components';

import {type TreeNodeWithPage} from './diff-grouping.ts';
import type {SchemaType} from '../../../features/allspicejson';

import DiffItem from './DiffItem.vue';

const props = defineProps<{
  changes: Record<string, TreeNodeWithPage[]>;
  schemaType: SchemaType;
  pageNameMap: Record<string, string>;
  diffTree: TreeNodeWithPage;
  navigationRootId?: string;
}>();

type ListItem = {
  groupName: string;
  item: TreeNodeWithPage;
};

const list = computed(() => {
  const items: ListItem[] = [];
  for (const groupName of Object.keys(props.changes)) {
    // add the changes under that group
    for (const change of props.changes[groupName]) {
      items.push({
        groupName,
        item: change,
      });
    }
  }

  return items;
});
</script>

<template>
  <UseVirtualList
    :list="list"
    :options="{
      itemHeight: 35
    }"
    height="100%"
  >
    <template #default="{ data }">
      <DiffItem
        :item="data.item"
        :group-name="data.groupName"
        :page-name="props.pageNameMap[data.item.page]"
        :schema-type="props.schemaType"
        :diff-tree="props.diffTree"
        :navigation-root-id="props.navigationRootId"
        spacing="tight"
      />
    </template>
  </UseVirtualList>
</template>
